import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { IRole } from '../interfaces/role.interface';
import { UserService } from './user.service';
import { EnvService } from 'src/app/services/env.service';

@Injectable()
export class RoleService {
  constructor(
    private readonly http: HttpClient,
    private userService: UserService,
    private env: EnvService
  ) {}

  readonly baseUrl = `${this.env.URL_API_V1}/role`;
  readonly baseUrlUnit = `${this.env.URL_API_V1}/unit`;

  getRolesByUnit(unit: string) {
    return this.http.get<IRole[]>(`${this.baseUrl}/getRolesByUnit/${unit}`);
  }

  getUnits() {
    return this.http.get<IUnit[]>(`${this.baseUrlUnit}/getAll`);
  }

  getAll() {
    return this.http.get<IRole[]>(`${this.baseUrl}/getAll`);
  }

  deleteRole(id) {
    return this.http.delete(
      `${this.baseUrl}/delete/${id}/${this.userService.currentUser._id}`
    );
  }

  createRole(data) {
    data.user_creator = this.userService.currentUser;
    return this.http.post<IRole>(`${this.baseUrl}/create`, data);
  }

  updateRole(id, newData) {
    newData.user_creator = this.userService.currentUser;
    return this.http.put<IRole>(`${this.baseUrl}/update/${id}`, newData);
  }

  changeStatus(id: string) {
    return this.http.get<IRole[]>(`${this.baseUrl}/changeStatus/${id}`);
  }
}
